module.exports = __webpack_public_path__ + "static/media/dr2-3.797468f4.jpg";